import { AllCompaniesThemeSizeConfig } from './types';

const small: AllCompaniesThemeSizeConfig = {
  allCompanies: {},
};

export default small;
